import http from '../../api/http';

const toParams = (filters = {}) => {
  const params = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== null && value !== undefined && String(value).trim() !== '') {
      params.set(key, value);
    }
  });

  const query = params.toString();
  return query ? `?${query}` : '';
};

export const fetchFirstFailAnalysis = (filters) => (
  http(`/api/production-root-cause/first-fail${toParams(filters)}`)
);

export const fetchMarginRiskAnalysis = (filters) => (
  http(`/api/production-root-cause/margin-risk${toParams(filters)}`)
);

export const fetchHotspotAnalysis = (filters) => (
  http(`/api/production-root-cause/hotspots${toParams(filters)}`)
);

export const fetchCascadeSpreadAnalysis = (filters) => (
  http(`/api/production-root-cause/cascade-spread${toParams(filters)}`)
);

export const fetchRetryPressureAnalysis = (filters) => (
  http(`/api/production-root-cause/retry-pressure${toParams(filters)}`)
);

export const fetchLateFailureCostAnalysis = (filters) => (
  http(`/api/production-root-cause/late-failure-cost${toParams(filters)}`)
);
